import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SmallStubPill from 'components/application/pills/SmallStubPill';
import Tooltip from 'components/application/Tooltip';

const colorClassName = {
  amber: 'tw-text-amber-800 tw-bg-amber-025',
  green: 'tw-text-green-800 tw-bg-green-025',
};
export default function ELearningCourseAutoEnrolsPill({ color, tooltipText }) {
  const { t: i18nTCourses } = useTranslation('common', {
    keyPrefix: 'courses',
  });

  return (
    <span className='tw-ml-2'>
      <Tooltip placement='top' tooltip={tooltipText} trigger='hover'>
        <SmallStubPill className={classNames(colorClassName[color])}>
          {i18nTCourses('autoEnrols')}
        </SmallStubPill>
      </Tooltip>
    </span>
  );
}

ELearningCourseAutoEnrolsPill.propTypes = {
  color: PropTypes.string,
  tooltipText: PropTypes.string,
};
